import React, { PropsWithChildren } from "react";
import { Button } from "@evidenceb/athena-common/design-system/Button";
import PopoverMenu, {
    Props as PopoverMenuProps,
} from "../../../../../design-system-components/PopoverMenu/PopoverMenu";

import "./GroupNamePopoverMenu.scss";

type Props = PropsWithChildren<{ label: string }> &
    Pick<PopoverMenuProps, "onAction">;

const GroupNamePopoverMenu = ({ label, children, onAction }: Props) => {
    return (
        <div className="group-name-menu">
            <PopoverMenu
                trigger={
                    <Button
                        className="group-name-menu__menu-button"
                        label={label}
                        hideLabel
                        icons={[
                            {
                                path: "more_vert",
                            },
                        ]}
                        variant="secondary"
                    />
                }
                popoverPlacement="bottom start"
                onAction={onAction}
            >
                {children}
            </PopoverMenu>
        </div>
    );
};

GroupNamePopoverMenu.Item = PopoverMenu.Item;

export default GroupNamePopoverMenu;
